var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1999 12.6594L14.2454 16.4994L15.2909 12.6594C15.5534 11.6949 15.6854 11.2119 15.9434 10.8144C16.171 10.4653 16.4689 10.1675 16.8179 9.93987C17.2125 9.68188 17.6954 9.55138 18.663 9.28738L22.5029 8.24187L18.663 7.19637C17.6985 6.93388 17.2169 6.80188 16.8179 6.54388C16.4689 6.31628 16.171 6.01845 15.9434 5.66937C15.6854 5.27487 15.5549 4.79187 15.2909 3.82437L14.2454 -0.015625L13.1999 3.82437C12.9374 4.78888 12.8054 5.27187 12.5474 5.66937C12.3198 6.01845 12.022 6.31628 11.6729 6.54388C11.2784 6.80188 10.7954 6.93237 9.82795 7.19637L5.98795 8.24187L9.82795 9.28738C10.7924 9.54988 11.2754 9.68188 11.6729 9.93987C12.022 10.1675 12.3198 10.4653 12.5474 10.8144C12.8054 11.2089 12.9359 11.6919 13.1999 12.6594ZM4.01995 20.5494C4.27345 20.9154 4.41595 21.3624 4.70395 22.2594L5.24695 23.9394L5.78995 22.2594C6.07645 21.3669 6.22045 20.9199 6.47395 20.5494C6.69745 20.2254 6.98395 19.9494 7.31545 19.7349C7.68895 19.4934 8.14045 19.3644 9.04045 19.1079L10.4969 18.6924L9.04045 18.2769C8.13895 18.0189 7.68745 17.8899 7.31545 17.6499C6.98416 17.4363 6.69822 17.1595 6.47395 16.8354C6.22045 16.4694 6.07795 16.0224 5.78995 15.1254L5.24695 13.4454L4.70395 15.1254C4.41745 16.0179 4.27345 16.4649 4.01995 16.8354C3.79645 17.1594 3.50995 17.4354 3.17845 17.6499C2.80495 17.8914 2.35345 18.0204 1.45345 18.2769L-0.00305176 18.6924L1.45345 19.1079C2.35495 19.3659 2.80645 19.4949 3.17845 19.7349C3.50973 19.9485 3.79568 20.2252 4.01995 20.5494Z",
    fill: "url(#paint0_linear_5045_9014)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5045_9014",
    x1: -0.638302,
    y1: 23.9394,
    x2: 42.0133,
    y2: 39.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E56489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352894,
    stopColor: "#AE1595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708393,
    stopColor: "#5230EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B55F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.0efadef603c302d2d3277e27090b1f7d.svg";
export { ForwardRef as ReactComponent };